import { Stack, Text, Textarea } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '@/components/common';

interface RejectInvoiceModalProps {
  opened: boolean;
  invoiceLabel: string;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  loading?: boolean;
  isPaused?: boolean;
}

/** Isti obrazac kao RejectOfferModal — tanak wrapper oko ConfirmActionModal s razlogom. */
export const RejectInvoiceModal = ({
  opened,
  invoiceLabel,
  onClose,
  onConfirm,
  loading,
  isPaused
}: RejectInvoiceModalProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <ConfirmActionModal
      opened={opened}
      onClose={handleClose}
      onConfirm={() => onConfirm(reason.trim())}
      loading={loading}
      isPaused={isPaused}
      confirmDisabled={!reason.trim()}
      danger
      title={t('invoiceDetail.rejectModalTitle')}
      message={t('invoiceDetail.rejectModalMessage', { number: invoiceLabel })}
      confirmLabel={t('invoiceDetail.rejectModalConfirm')}
    >
      <Stack gap={6}>
        <Text fz={11} fw={600} style={{ color: 'var(--color-text-muted)', letterSpacing: 0.4 }}>
          {t('invoiceDetail.rejectModalReasonLabel')}
        </Text>
        <Textarea
          value={reason}
          onChange={(event) => setReason(event.currentTarget.value)}
          placeholder={t('invoiceDetail.rejectModalReasonPlaceholder')}
          autosize
          minRows={4}
          styles={{
            input: {
              backgroundColor: 'var(--color-bg-surface-2)',
              borderColor: 'var(--color-border-default)',
              color: 'var(--color-text-primary)'
            }
          }}
        />
      </Stack>
    </ConfirmActionModal>
  );
};
